module.exports = __webpack_public_path__ + "static/media/auchan6.d019f50f.jpg";